module.exports = __webpack_public_path__ + "assets/59eb24100ca709488123af58d6c99d54.svg";